'use client'

import classNames from 'classnames'
import { COOKIE_PREFERENCES_LABEL } from 'constants/footer'
import { useIsOsanoCmpActive } from 'context/common/OsanoCmpContext'
import { showOsanoCookiePreferences } from 'lib/showOsanoCookiePreferences'
import styles from './index.module.scss'

type CookiePreferencesLinkProps = {
  className?: string
}

const CookiePreferencesLink: React.FC<CookiePreferencesLinkProps> = ({
  className,
}) => {
  const isOsanoCmpActive = useIsOsanoCmpActive()

  if (!isOsanoCmpActive) {
    return null
  }

  return (
    <button
      type="button"
      className={classNames(styles.footer_link_button, className)}
      onClick={showOsanoCookiePreferences}
    >
      {COOKIE_PREFERENCES_LABEL}
    </button>
  )
}

export default CookiePreferencesLink
